import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Subject, switchMap } from 'rxjs';
import { BookshelfAPIService } from 'shared/services';
import { DialogService, TypedDialog } from 'shared/ui';

@Component({
  selector: 'lib-add-bookshelf',
  templateUrl: './add-bookshelf.component.html',
  styleUrl: './add-bookshelf.component.scss',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'mobile-full-height' },
})
export class AddBookshelfComponent
  extends TypedDialog<void, { canceled: 'success' | 'failed' }>
  implements OnInit, OnDestroy
{
  private _addBookshelfSubject = new Subject<void>();
  private _submitLoadingIndicatorTimer: ReturnType<typeof setTimeout> | null =
    null;

  public _inputBookshelfValue: string = '';
  public _isPublic: 0 | 1 = 0;
  public _isSaving = false;
  public _showSubmitLoadingIndicator = false;

  constructor(
    private _dialogService: DialogService,
    private _bookshelfAPIService: BookshelfAPIService,
    private _ngZone: NgZone
  ) {
    super();
  }

  ngOnInit(): void {
    this._addBookshelfSubject
      .pipe(
        switchMap(() => {
          return this._bookshelfAPIService.createBookshelf(
            this._inputBookshelfValue,
            this._isPublic
          );
        })
      )
      .subscribe({
        next: () => {
          this._clearSubmitLoadingIndicatorTimer();
          this._dialogRef.close({ canceled: 'success' });
        },
        error: () => {
          this._clearSubmitLoadingIndicatorTimer();
          this._isSaving = false;
          this._showSubmitLoadingIndicator = false;
        },
      });
  }

  ngOnDestroy(): void {
    this._clearSubmitLoadingIndicatorTimer();
    this._addBookshelfSubject.complete();
  }

  public _closeDialog(): void {
    this._dialogRef.close();
  }

  public _changeIsPublic(event: any): void {
    if (event.srcElement.checked) {
      this._isPublic = 1;
    } else {
      this._isPublic = 0;
    }
  }

  public _onClickSubmit(): void {
    if (this._isSaving) {
      return;
    }

    this._clearSubmitLoadingIndicatorTimer();
    this._showSubmitLoadingIndicator = false;
    this._isSaving = true;
    this._submitLoadingIndicatorTimer = setTimeout(() => {
      this._submitLoadingIndicatorTimer = null;
      this._ngZone.run(() => {
        if (this._isSaving) {
          this._showSubmitLoadingIndicator = true;
        }
      });
    }, 1000);

    this._addBookshelfSubject.next();
  }

  private _clearSubmitLoadingIndicatorTimer(): void {
    if (this._submitLoadingIndicatorTimer !== null) {
      clearTimeout(this._submitLoadingIndicatorTimer);
      this._submitLoadingIndicatorTimer = null;
    }
  }
}
